import { render, staticRenderFns } from "./EvaluacionesRealizadasPage.vue?vue&type=template&id=33ea2ff7&scoped=true&"
import script from "./EvaluacionesRealizadasPage.vue?vue&type=script&lang=js&"
export * from "./EvaluacionesRealizadasPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ea2ff7",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/evaluacion-docente/EvaluacionesRealizadasPage.vue
// module id = 204
// module chunks = 15